const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Iconoclasm extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.Iconoclasm,
            "Each civilization with a leader that is not from the current age must remove that leader from play.",
            {}
        )
    }
}

module.exports = Iconoclasm;